import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { AppSessionService } from "../app-session/app-session.service";

@Injectable({
  providedIn: "root",
})
export class DispenserService {
  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}

  createDispenser(dispenser): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(dispenser);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/fuelDispensers"}`;
    return this.http.post(url, data, { headers });
  }

  updateDispenser(dispenser): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(dispenser);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/fuelDispensers"}/${
      dispenser?.code
    }`;
    return this.http.put(url, data, { headers });
  }
}
